import React from 'react';

// SVG Flower component - Cherry Blossom style
export const CherryBlossom = ({ className = "", size = 60, color = "#D4A5A5" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    fill="none"
  >
    {/* Petals */}
    <ellipse cx="50" cy="25" rx="12" ry="20" fill={color} opacity="0.8" transform="rotate(0 50 50)" />
    <ellipse cx="50" cy="25" rx="12" ry="20" fill={color} opacity="0.8" transform="rotate(72 50 50)" />
    <ellipse cx="50" cy="25" rx="12" ry="20" fill={color} opacity="0.8" transform="rotate(144 50 50)" />
    <ellipse cx="50" cy="25" rx="12" ry="20" fill={color} opacity="0.8" transform="rotate(216 50 50)" />
    <ellipse cx="50" cy="25" rx="12" ry="20" fill={color} opacity="0.8" transform="rotate(288 50 50)" />
    {/* Center */}
    <circle cx="50" cy="50" r="10" fill="#F5E1E1" />
    <circle cx="48" cy="48" r="2" fill="#D4A5A5" />
    <circle cx="52" cy="48" r="2" fill="#D4A5A5" />
    <circle cx="50" cy="52" r="2" fill="#D4A5A5" />
  </svg>
);

// Decorative leaf
export const DecorativeLeaf = ({ className = "", size = 40, color = "#6E9EB9" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 50 50" 
    className={className}
    fill="none"
  >
    <path 
      d="M25 5 C15 15 10 30 25 45 C40 30 35 15 25 5" 
      fill={color} 
      opacity="0.6"
    />
    <path 
      d="M25 10 L25 40" 
      stroke="white" 
      strokeWidth="1" 
      opacity="0.5"
    />
  </svg>
);

// Small star/sparkle
export const Sparkle = ({ className = "", size = 20, color = "#D4A5A5" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
  >
    <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
  </svg>
);

// Decorative dots pattern
export const DotsPattern = ({ className = "" }) => (
  <svg 
    width="100" 
    height="100" 
    viewBox="0 0 100 100" 
    className={className}
    fill="none"
  >
    {[0, 1, 2, 3, 4].map(row => 
      [0, 1, 2, 3, 4].map(col => (
        <circle 
          key={`${row}-${col}`}
          cx={10 + col * 20} 
          cy={10 + row * 20} 
          r="3" 
          fill="#D4A5A5" 
          opacity="0.3"
        />
      ))
    )}
  </svg>
);

// Curved branch with blossoms
export const BlossomBranch = ({ className = "", flip = false }) => (
  <svg 
    width="200" 
    height="150" 
    viewBox="0 0 200 150" 
    className={className}
    fill="none"
    style={{ transform: flip ? 'scaleX(-1)' : 'none' }}
  >
    {/* Branch */}
    <path 
      d="M0 100 Q50 80 100 90 T200 60" 
      stroke="#8B7355" 
      strokeWidth="3" 
      fill="none"
      opacity="0.6"
    />
    {/* Blossoms */}
    <g transform="translate(40, 75)">
      <circle cx="0" cy="0" r="8" fill="#D4A5A5" opacity="0.7" />
      <circle cx="6" cy="-4" r="6" fill="#E8C4C4" opacity="0.8" />
      <circle cx="-5" cy="-3" r="5" fill="#F5E1E1" opacity="0.9" />
    </g>
    <g transform="translate(90, 85)">
      <circle cx="0" cy="0" r="10" fill="#D4A5A5" opacity="0.7" />
      <circle cx="8" cy="-5" r="7" fill="#E8C4C4" opacity="0.8" />
      <circle cx="-6" cy="-4" r="6" fill="#F5E1E1" opacity="0.9" />
    </g>
    <g transform="translate(150, 55)">
      <circle cx="0" cy="0" r="9" fill="#D4A5A5" opacity="0.7" />
      <circle cx="7" cy="-4" r="6" fill="#E8C4C4" opacity="0.8" />
      <circle cx="-5" cy="-3" r="5" fill="#F5E1E1" opacity="0.9" />
    </g>
  </svg>
);

// Wave decoration
export const WaveDecoration = ({ className = "", color = "#D4A5A5" }) => (
  <svg 
    viewBox="0 0 1440 100" 
    className={className}
    preserveAspectRatio="none"
  >
    <path 
      d="M0 50 Q360 0 720 50 T1440 50 L1440 100 L0 100 Z" 
      fill={color}
      opacity="0.1"
    />
  </svg>
);

// Floating decoration wrapper
export const FloatingDecoration = ({ children, delay = 0, duration = 6 }) => (
  <div 
    className="animate-float-slow"
    style={{ 
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`
    }}
  >
    {children}
  </div>
);

// Combined decorative corner
export const DecorativeCorner = ({ position = "top-left", className = "" }) => {
  const positionClasses = {
    "top-left": "top-0 left-0",
    "top-right": "top-0 right-0 rotate-90",
    "bottom-left": "bottom-0 left-0 -rotate-90",
    "bottom-right": "bottom-0 right-0 rotate-180"
  };

  return (
    <div className={`absolute ${positionClasses[position]} pointer-events-none ${className}`}>
      <BlossomBranch flip={position.includes('right')} />
    </div>
  );
};

export default {
  CherryBlossom,
  DecorativeLeaf,
  Sparkle,
  DotsPattern,
  BlossomBranch,
  WaveDecoration,
  FloatingDecoration,
  DecorativeCorner
};
